import React from 'react'
import { TilesDesktop, TilesMobileCarousel, TilesMobileStacked } from './sizes'

interface HowItWorksTilesProps {
  mobileBehavior?: 'carousel' | 'stacked'
}

export const HowItWorksTiles = ({
  mobileBehavior = 'stacked',
}: HowItWorksTilesProps) => (
  <>
    <div className='d-block d-md-none'>
      {mobileBehavior === 'stacked' && <TilesMobileStacked />}
      {mobileBehavior === 'carousel' && <TilesMobileCarousel />}
    </div>
    <div className='d-none d-md-block'>
      <TilesDesktop />
    </div>
  </>
)
